<div class="flex flex-col items-center w-full p-4">
    <!-- <div class="relative w-24 h-24">
        <img
            class="w-full h-full rounded-full"
            *ngIf="user.photo_profile"
            [src]="user.photo_profile.thumbnail_150"
            alt="User avatar">
        <mat-icon
            class="icon-size-24"
            *ngIf="!user.photo_profile"
            [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
    </div> -->

    <div
    class="w-24 h-24 group relative flex items-center justify-center rounded-full overflow-hidden ring-bg-card">
    <div class="hidden group-hover:flex absolute inset-0 flex-col items-center justify-center backdrop-filter backdrop-blur bg-opacity-80 rounded-full cursor-pointer bg-gray-800"
        (click)="file.click()">
        <mat-icon class="text-white" [svgIcon]="'heroicons_outline:camera'"></mat-icon>
        <div class="mt-2 mx-6 font-medium text-center text-white" translate>
            menu.profil.fuse.change_photo
        </div>        
    </div>
    <ng-container *ngIf="user && user.photo_profile?.photo_identity">
        <img class="w-full h-full rounded-full object-cover"
            src="{{ user.photo_profile?.photo_identity }}">
    </ng-container>
    <ng-container *ngIf="!user || !user.photo_profile?.photo_identity">
        <div
            class="flex items-center justify-center w-full h-full rounded-full text-8xl font-semibold uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
            <mat-icon class="icon-size-24" [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
        </div>
    </ng-container>
    <input #file type="file" (change)="uploadAvatar($event)" [hidden]="true" />
</div>
    <div class="flex flex-col items-center justify-center w-full mt-6" *ngIf="user">
        <div class="w-full whitespace-nowrap overflow-ellipsis overflow-hidden text-center leading-normal font-medium">
            {{user.first_name}} {{user.last_name}}
        </div>
        <div class="w-full mt-0.5 whitespace-nowrap overflow-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
            {{user.email}}
        </div>
    </div>
</div>